import * as THREE from "three";
import { ZONE } from "@mucki/shared";

export function addLighting(scene: THREE.Scene): void {
  const ambient = new THREE.HemisphereLight(0xbfd8e8, 0x40602f, 1.1);
  scene.add(ambient);

  const sun = new THREE.DirectionalLight(0xfff2d5, 1.6);
  sun.position.set(30, 45, 20);
  sun.castShadow = true;
  sun.shadow.mapSize.set(2048, 2048);

  const half = ZONE.size / 2;
  sun.shadow.camera.left = -half;
  sun.shadow.camera.right = half;
  sun.shadow.camera.top = half;
  sun.shadow.camera.bottom = -half;
  sun.shadow.camera.near = 1;
  sun.shadow.camera.far = 160;
  scene.add(sun);
  scene.add(sun.target);
}
